import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import communityApi from '../../api/communityApi';
import { SettingInterface } from "../../store/community/settingsSlice";

const PREFIX = 'community';

const processStrategy = (value: any) => {
  return {
    ...value
  };
}

export const settingEntity = new schema.Entity(
  'setting',
  {},
  {
    processStrategy
  }
);


export const settingsEntity = new schema.Entity(
  'settings',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      setting: SettingInterface
    }
  >(response.data.setting, settingEntity);

  return normalized.entities;
}

export const fetchSetting = createAsyncThunk(
  `${PREFIX}_settings/fetchSetting`,
  async (id: number) => {
    const response = await communityApi.get(`/onesky/settings/${id}`)

    return normalizeInstance(response);
  }
);

export const updateSetting = createAsyncThunk(
  `${PREFIX}_11settings/updateSetting`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await communityApi.patch(`/onesky/settings/${id}`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
